// extracted by mini-css-extract-plugin
module.exports = {"increment":"AddToBasket_increment__G2xXQ","price":"AddToBasket_price__q7XBq","count":"AddToBasket_count__uAO6G"};